/**
 * If you change this list, update the list on Beef server side.
 */
export const FONTS = {
    "roto-kufi": "Roto Kufi Arabic",
    "open-sans": "Open Sans"
};